import React from "react";

export default function Copyright(){
    return(
        <div className="copy">
        Copyright 
        <span style={{marginLeft: "5px"}}>
            <img src="../../assets/footer/copy.svg"></img>
        </span>
        2024 | SMA Laboratorium UM
        </div>
    )
}